import React from "react"
import { useContext } from 'react';
import { PhoneWidgetPropsContext } from './provider';

export default function usePhoneWidgetProps() {
    const context = useContext(PhoneWidgetPropsContext)

    if (!context) throw new Error('usePhoneWidgetProps must be used within a PhoneWidgetPropsProvider')

    return context
}
